import React from "react";
import loaderImg from "../../../../assets/UFC_DC_V1/img/loader-review2.svg";
import "../../../../assets/FLPSignConfirm/scss/loader.scss";

const LoadingLoader = ({ redirectloader }) => {

  return (
    <div className={`text-center loader loader1 align-content-center fade-in ${redirectloader}`}>
      <div className="inner py-5">
        <div className="my-3">
          <img height="70" src={loaderImg} alt="Loading..." />
        </div>
        <h2 className="px-4"> Please wait...</h2>
      </div>
    </div>
  );
};

export default LoadingLoader;
